<soft-page>
  <soft-page-header>
    <div class="flex flex-row justify-between w-full">
      <div class="flex flex-row items-center">
        <ng-container *ngTemplateOutlet="header()?.template() ?? null"></ng-container>
      </div>
      <div class="justify-end">
        @if (shortcuts().length > 0) {
          <soft-query-page-shortcuts
            [shortcuts]="shortcuts()"
            (shortcutClick)="onShortcutClick($event)"
          >
          </soft-query-page-shortcuts>
        }
      </div>
    </div>
  </soft-page-header>
  <ng-content></ng-content>
</soft-page>
